import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Alert } from "@mui/material";

import {
  formatPendingOffPlatformBookingAmount,
  formatPendingOffPlatformBookingCarrier,
} from "components/Shipper/components/MarkBookedOffPlatformModal";

import type { PendingOffPlatformBooking } from "hooks";

interface Props {
  pendingOffPlatformBooking: PendingOffPlatformBooking | null;
}

export function PendingOffPlatformBookingSection(props: Props) {
  const { pendingOffPlatformBooking } = props;

  if (pendingOffPlatformBooking === null) {
    return null;
  }

  const amount = formatPendingOffPlatformBookingAmount(
    pendingOffPlatformBooking,
  );
  const carrier = formatPendingOffPlatformBookingCarrier(
    pendingOffPlatformBooking,
  );
  // A company name such as "Some Carrier Inc." already ends the sentence.
  const sentenceEnd = carrier.endsWith(".") ? "" : ".";

  return (
    <Alert
      severity="info"
      icon={<AccessTimeIcon />}
      sx={{ my: "1rem", py: "0.8rem", alignItems: "center" }}
    >
      {`Support is working on recording the off-platform booking for ${amount} with carrier ${carrier}${sentenceEnd}`}
    </Alert>
  );
}
